import { DataTableDropDownData } from "../component/controls/datatable/datatable.component";
import { TaskStatus } from "./TaskStatus";

export class PlanInfo {
    count: number;
    plans: Plan[];
}

export class Plan {
    createdBy: string;
    createdDateTime: Date;
    description: string;
    exportUrl: string;
    hasAccess: boolean;
    canExec: boolean = false;
    id: number;
    name: string;
    selectedEnvironmentId: number;
    selectedEnvironmentName: string;
    steps: Step[] = [];
    systemVariables: SystemVariable[] = [];
    updatedBy: number;
    updatedDateTime: Date;
    variables: Variable[] = [];
    selected: boolean;
    showInlineMenu: boolean;
    saveType: string;
}

export class Step {
    disabled: boolean;
    nickname: string;
    label: string;
    notes: string;
    parameters: Record<string, Parameter>;
    platform: string;
    plugin: string;
    product: string;
    stepNo: number;
    summary: string;
    tabOrder: string[];
    selectedSystemVar: SystemVariable;
    type: string;
    variableMap: Record<string, string>;
    showSysVar: boolean;
    expanded: boolean;
    paramTabIndex: number = 0;
    currentParamTabName: string = 'Default';
    parameterGroups: string[];
    macAddress: string;
    status: TaskStatus;
    tabTemplate: Record<string, Parameter>;
}

export class StepUI {
    step:Step;
    //UI
    dragHandle: any;
    uiDisplayName: any;
    dragPreview: string;
    uiStatus: any;
    uiSystemVariables: DataTableDropDownData;
    uiStepValidation: StepValidation;
}

export class StepValidation {
    type: STEP_VALIDATION_TYPE;
    reason: string;
}

export enum STEP_VALIDATION_TYPE{
    VALID,
    REQ_PARAM_MISSING_ERROR,
    SYSVAR_ERROR
}

export class SystemVariable {
    count: number;
    name: string;
    value: string;
}

export class Variable {
    count: number;
    name: string;
    type: string;
    value: any;
    parameter:Parameter;
    sensitive: boolean;
}

export class Parameter {
    allowImport: boolean;
    constraints: Constraint[];
    defaultListValue: any[];
    defaultValue: string;
    defaultValueCallback: string;
    dependencies: Dependency[];
    description: string;
    displayName: string;
    group: string;
    name: string;
    data: string;
    changeEvent: string;
    dependentParameter: string;
    objectDefinition: Record<string, ObjectField>;
    objectList: Record<string, ObjectField>[];
    order: number;
    required: boolean;
    sensitive: boolean;
    supportsVariable: boolean;
    type: string;
    visible: boolean;
    value: any;
    valueList: any[];
    focus: boolean;
    varSearch:string;
    variableName:string;
    isClusterValue:boolean;
    isSensitiveVariable:boolean;
}

export class ObjectField {
    defaultListValue: any[];
    name: string;
    order: number;
    type: string;
    value: string = '';
}

export class Constraint {
    name: string;
    plugin: string;
    value: string;
}

export class Dependency {
    callback: string;
    name: string;
    validated: boolean;
    value: string;
    callbackValue: string;
}

export class PreRequisiteStepError {
    step: Step;
    parameters: PreRequisiteParameterError[];
    isAgentRegistered: boolean;
    isAgentEnvironment: boolean;
    isAgentOnline: boolean;
    isAgentActive: boolean;
    num: number;
    nickName: string;
}

export class PreRequisiteParameterError {
    type: PREREQ_PARAM_ERROR_TYPE;
    parameter: Parameter;
}

export enum PREREQ_PARAM_ERROR_TYPE {
    PRODUCT_FILE = "PRODUCT_FILE",
    EXT_FILE = "EXT_FILE"
}

export class ExecutePlanRequest {
    steps: Step[];
    variableMap: Record<string, Variable>;

    constructor(steps: Step[], variableMap: Record<string, Variable>) {
        this.steps = steps;
        this.variableMap = variableMap;
    }
}